import { styled } from '@linaria/react';
import { layout, primitives, semantic, size, space } from '../../theme/tokens';
import { EntityImage } from '../EntityImage';

export const Outer = styled.div`
  position: relative;
  width: 100%;
  flex-shrink: 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    height: 100%;
    padding: var(--image-frame-desktop-padding, ${layout.horizontalPadding});
    box-sizing: border-box;
  }
`;

export const OuterSticky = styled.div`
  position: relative;
  width: 100%;
  flex-shrink: 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    height: 100%;
    padding: var(--image-frame-desktop-padding, ${layout.horizontalPadding});
    box-sizing: border-box;
    position: sticky;
    top: 0;
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: var(--image-frame-mobile-height, auto);
  aspect-ratio: var(--image-frame-mobile-aspect-ratio, 16 / 9);
  max-height: var(--image-frame-mobile-max-height, none);
  overflow: hidden;

  @media (min-width: ${layout.desktopBreakpoint}) {
    height: var(--image-frame-desktop-height, 100%);
    aspect-ratio: auto;
    max-height: none;
    border-radius: var(--image-frame-desktop-radius, ${size.radius['radius-md']});
  }
`;

export const Img = styled(EntityImage)`
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
`;

export const Placeholder = styled.div`
  width: 100%;
  height: 100%;
  aspect-ratio: var(--image-frame-mobile-aspect-ratio, 16 / 9);
  background: ${semantic.bg.surfaceSubtle};
  border-radius: inherit;
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: ${space['space-800']};
  background: linear-gradient(${primitives.color.black['color-black-alpha-600']}, transparent);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${space['space-300']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space['space-1200']};
    border-radius: ${size.radius['radius-md']} ${size.radius['radius-md']} 0 0;
    background: none;
    justify-content: center;
  }
`;

export const OverlayContentSlot = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  justify-content: center;
`;

export const BadgeContainer = styled.div`
  position: absolute;
  bottom: ${space['space-600']};
  left: ${space['space-600']};
  z-index: 2;
`;
